import { RESET_RESPONSE } from "../types"

export default function resetResponse() {
    return { type: RESET_RESPONSE }
}